import * as React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'
import { InternetList } from 'features/Internet/InternetList'

export interface IInternetProps {
  location: {
    query: {
      page?: string
    }
  }
}

export class Internet extends React.Component<IInternetProps> {
  render() {
    const { location } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Internet Services">
        <PageHeader>
          <Crumbs title="Internet Services" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          <InternetList page={parseInt(location.query.page || '1', 10)} />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Internet/Internet.tsx